import { CVCompetenceGroupsService } from "../../core/cvcompetencegroups.dataservice";
import { Ng2StateDeclaration } from "@uirouter/angular";
import { CVCompetenceGroups } from "./cvcompetencegroups.component";
import { EditCVCompetenceGroup } from "./cvcompetencegroup.edit.component";
import { CVCompetenceGroup } from "./cvcompetencegroup.component";

/**
 * This state displays all CV Competence Groups
 */
export const cvCompetenceGroupsState: Ng2StateDeclaration = {
    name: "app.settings.cvcompetencegroups",
    url: "/cvcompetencegroups",
    views: {
        "main-view@app": {
            component: CVCompetenceGroups
        }
    },
    resolve: {
        cvcompetencegroups: ["cvCompetenceGroupsService", (cvCompetenceGroupsService: CVCompetenceGroupsService) => {
            return cvCompetenceGroupsService.getAll();
        }]
    }
};

/**
 * This state is for creating a new CV Competence Group
 */
export const newCvCompetenceGroupState: Ng2StateDeclaration = {
    name: "app.settings.cvcompetencegroups.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: EditCVCompetenceGroup
        }
    },
    resolve: {
        cvcompetencegroup: function() {
            return <Nema.Crew.Model.CVCompetenceGroup>{
                Id: -1, Name: "", Active: true, SortTag: "", Description: "", CompetenceTypeCVMappings: null, InclusionMode: 0
            };
        },
        isNew: function() {
            return true;
        }
    }
};

/**
 * This state is for editing a CV Competence Group
 */
export const editCvCompetenceGroupState: Ng2StateDeclaration = {
    name: "app.settings.cvcompetencegroups.edit",
    url: "/{id:int}/edit",
    views: {
        "main-view@app": {
            component: EditCVCompetenceGroup
        }
    },
    resolve: {
        cvcompetencegroup: ["cvCompetenceGroupsService", "$stateParams", function(cvCompetenceGroupsService: CVCompetenceGroupsService, $stateParams) {
            return cvCompetenceGroupsService.get($stateParams.id);
        }],
        isNew: function() {
            return false;
        }
    }
};

/**
 * CV Competence Group Details state
 */
export const cvCompetenceGroupState: Ng2StateDeclaration = {
    name: "app.settings.cvcompetencegroups.detail",
    url: "/{id:int}",
    views: {
        "main-view@app": {
            component: CVCompetenceGroup
        }
    },
    resolve: {
        cvcompetencegroup: ["cvCompetenceGroupsService", "$stateParams", function(cvCompetenceGroupsService: CVCompetenceGroupsService, $stateParams) {
            return cvCompetenceGroupsService.get($stateParams.id);
        }]
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/cvcompetencegroups/cvcompetencegroups.states.ts